import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconXFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m12 13.054 3.073 3.073c.138.138.313.21.522.213a.707.707 0 0 0 .532-.213.718.718 0 0 0 .217-.527.718.718 0 0 0-.217-.527L13.054 12l3.073-3.073a.726.726 0 0 0 .213-.522.708.708 0 0 0-.213-.532.718.718 0 0 0-.527-.217.718.718 0 0 0-.527.217L12 10.946 8.927 7.873a.726.726 0 0 0-.522-.213.708.708 0 0 0-.532.213.718.718 0 0 0-.217.527c0 .206.072.382.217.527L10.946 12l-3.073 3.073a.726.726 0 0 0-.213.522.707.707 0 0 0 .213.532c.145.145.32.217.527.217a.718.718 0 0 0 .527-.217L12 13.054Zm.002 8.446a9.254 9.254 0 0 1-3.706-.748 9.596 9.596 0 0 1-3.016-2.03 9.595 9.595 0 0 1-2.032-3.016 9.246 9.246 0 0 1-.748-3.704c0-1.314.25-2.55.748-3.706a9.596 9.596 0 0 1 2.03-3.016 9.594 9.594 0 0 1 3.016-2.032 9.246 9.246 0 0 1 3.704-.748c1.314 0 2.55.25 3.706.748a9.596 9.596 0 0 1 3.017 2.03 9.594 9.594 0 0 1 2.03 3.016 9.247 9.247 0 0 1 .749 3.704 9.27 9.27 0 0 1-.748 3.706 9.596 9.596 0 0 1-2.03 3.017 9.595 9.595 0 0 1-3.016 2.03 9.247 9.247 0 0 1-3.704.749Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconXFill;
